/**
 * Consistency · kundlager ovanpå Horizon
 *
 * VIKTIGT OM SCROLL: i Horizon 4 är .page-wrapper scrollcontainer, inte fönstret.
 * window.scrollY står därför alltid på 0 och 'scroll' på window fyras aldrig.
 * Uppmätt på både bygget och orörd stock 2026-08-25, och verifierat igen
 * 2026-08-27: 70 hjulsteg gav 0 händelser på window och 70 på .page-wrapper.
 * Därför lyssnar vi på document i capture-fas, vilket fångar scroll från
 * vilket element som helst.
 *
 * Heron har ingen scrollstyrd rörelse. Den låg i assets/consistency-hero.js
 * och togs bort 2026-08-27, se den filens huvud för orsaken.
 *
 * Allt innehåll är läsbart utan JavaScript och all rörelse stängs av vid
 * reducerad rörelse.
 */

(function () {
  'use strict';

  var lugnt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pascroll(fn) {
    document.addEventListener('scroll', fn, { passive: true, capture: true });
    window.addEventListener('resize', fn, { passive: true });
  }

  /* Intoning. Ett block högre än vyn tonar sina barn i stället för sig självt. */

  function markeraMal() {
    var vy = window.innerHeight;
    document
      .querySelectorAll('[data-con-in], main .shopify-section > * > *, main .con-siffror__post')
      .forEach(function (el) {
        if (el.hasAttribute('data-con-klar') || el.hasAttribute('data-con-mal')) return;
        if (el.closest('.con-hero__lager') && !el.hasAttribute('data-con-in')) return;
        if (el.closest('.con-manifest')) return;
        var h = el.getBoundingClientRect().height;
        if (h > vy * 0.75 && !el.hasAttribute('data-con-in')) {
          el.setAttribute('data-con-omslag', '1');
          return;
        }
        el.setAttribute('data-con-mal', '1');
      });
  }

  var obs = null;

  function startaIntoning() {
    if (lugnt || !('IntersectionObserver' in window)) {
      document.documentElement.setAttribute('data-con-rorelse', 'av');
      return;
    }
    document.documentElement.setAttribute('data-con-rorelse', 'pa');
    markeraMal();

    if (!obs) {
      obs = new IntersectionObserver(
        function (poster) {
          poster.forEach(function (post) {
            if (!post.isIntersecting) return;
            var el = post.target;
            var ordning = parseInt(el.getAttribute('data-con-in') || '0', 10);
            el.style.transitionDelay = ordning ? ordning * 90 + 'ms' : '0ms';
            el.setAttribute('data-con-inne', '1');
            el.setAttribute('data-con-klar', '1');
            obs.unobserve(el);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
      );
    }
    document.querySelectorAll('[data-con-mal]:not([data-con-klar])').forEach(function (el) {
      obs.observe(el);
    });
  }

  function laddningssekvens() {
    var hero = document.querySelector('.con-hero');
    if (!hero) return;
    if (lugnt) { hero.setAttribute('data-con-laddad', '1'); return; }
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        hero.setAttribute('data-con-laddad', '1');
      });
    });
  }

  /* Manifestet. Utan JavaScript ligger hela texten vaken.
     Sektionen ligger inte på någon sida i dag, se CUSTOMIZATIONS.md. */

  function manifest() {
    var rot = document.querySelector('.con-manifest');
    if (!rot || lugnt) return;
    var text = rot.querySelector('[data-con-manifest]');
    if (!text) return;

    var ord = [];
    var gangare = document.createTreeWalker(text, NodeFilter.SHOW_TEXT, null);
    var noder = [];
    var n;
    while ((n = gangare.nextNode())) noder.push(n);

    noder.forEach(function (nod) {
      var delar = nod.nodeValue.split(/(\s+)/);
      if (delar.length < 2) return;
      var frag = document.createDocumentFragment();
      delar.forEach(function (del) {
        if (/^\s+$/.test(del) || del === '') {
          frag.appendChild(document.createTextNode(del));
        } else {
          var s = document.createElement('span');
          s.className = 'con-ord';
          s.textContent = del;
          frag.appendChild(s);
          ord.push(s);
        }
      });
      nod.replaceWith(frag);
    });

    if (!ord.length) return;
    rot.setAttribute('data-igang', '1');

    var vantar = false;
    var hojd = 1;

    function mat() {
      hojd = Math.max(1, rot.offsetHeight - window.innerHeight);
    }

    function rita() {
      vantar = false;
      var box = rot.getBoundingClientRect();
      var t = Math.min(1, Math.max(0, -box.top / hojd));
      var vakna = Math.round(Math.min(1, t / 0.62) * ord.length);
      for (var i = 0; i < ord.length; i++) {
        if (i < vakna) ord[i].setAttribute('data-vaken', '1');
        else ord[i].removeAttribute('data-vaken');
      }
    }

    function pa() {
      if (vantar) return;
      vantar = true;
      window.requestAnimationFrame(rita);
    }

    /* Höjden mäts vid resize, inte i varje bildruta. offsetHeight tvingar fram
       en layoutberäkning, och att läsa den mitt i en scroll var en av orsakerna
       till att heros motsvarande effekt hackade. */
    mat();
    window.addEventListener('resize', mat, { passive: true });
    pascroll(pa);
    rita();
  }

  /* Prisskydd. Skyddsnät så länge priserna är platshållare. */

  var NOLLPRIS = /^\s*0([.,]0{1,2})?\s*(kr|SEK)\s*$/i;

  function bytNollpriser() {
    document.querySelectorAll('[class*="price"]').forEach(function (nod) {
      if (nod.querySelector('.con-pris-saknas')) return;
      var gangare = document.createTreeWalker(nod, NodeFilter.SHOW_TEXT, null);
      var traffar = [];
      var n;
      while ((n = gangare.nextNode())) {
        if (NOLLPRIS.test(n.nodeValue)) traffar.push(n);
      }
      traffar.forEach(function (textnod) {
        var f = textnod.parentElement;
        if (!f || f.classList.contains('con-pris-saknas')) return;
        var span = document.createElement('span');
        span.className = 'con-pris-saknas';
        span.textContent = 'Pris sätts inom kort';
        textnod.replaceWith(span);
      });
    });
  }

  function start() {
    laddningssekvens();
    startaIntoning();
    manifest();
    bytNollpriser();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  var vantarOm = false;
  new MutationObserver(function (poster) {
    if (vantarOm) return;
    if (!poster.some(function (p) { return p.addedNodes.length > 0; })) return;
    vantarOm = true;
    window.requestAnimationFrame(function () {
      vantarOm = false;
      bytNollpriser();
      if (!lugnt) startaIntoning();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
